import React from 'react';
import { IconType, Theme } from '@routific/hive';
import ScheduleWarningText from '../atoms/ScheduleWarningText';
import { StyledMessageBody, StyledMessageIcon } from '../styles/MessageStyles';

interface QuestionableStopsWarningMessageProps {
  message: string;
  reason: string;
}

const QuestionableStopsWarningMessage: React.FC<QuestionableStopsWarningMessageProps> = ({ message, reason }) => {

  return (
    <StyledMessageBody>
      <StyledMessageIcon
        icon={IconType.Warning}
        type="warning"
      />
      <ScheduleWarningText color={Theme.Colors.warning6}>{message}</ScheduleWarningText>
      <ScheduleWarningText>{reason}</ScheduleWarningText>
    </StyledMessageBody>
  );
}
  ;

export default QuestionableStopsWarningMessage;
